/**
 * MN Contact form — multi-select dropdown for Wholesaler interest field.
 * Syncs checked options into a hidden input for Shopify contact submissions.
 */
(function () {
  function initMultiselect(root) {
    if (!root || root.dataset.mnMultiselectReady === 'true') return;
    root.dataset.mnMultiselectReady = 'true';

    var trigger = root.querySelector('[data-mn-multiselect-trigger]');
    var panel = root.querySelector('[data-mn-multiselect-panel]');
    var labelEl = root.querySelector('[data-mn-multiselect-label]');
    var valueInput = root.querySelector('[data-mn-multiselect-value]');
    var checkboxes = root.querySelectorAll('[data-mn-multiselect-option]');
    var placeholder = root.dataset.placeholder || 'Select…';
    var form = root.closest('form');

    if (!trigger || !panel || !labelEl || !valueInput || !checkboxes.length) return;

    function selectedValues() {
      return Array.prototype.slice
        .call(checkboxes)
        .filter(function (box) {
          return box.checked;
        })
        .map(function (box) {
          return box.value;
        });
    }

    function sync() {
      var values = selectedValues();
      valueInput.value = values.join(' | ');
      labelEl.textContent = values.length ? values.join(', ') : placeholder;
      root.classList.toggle('mn-contact__multiselect--has-value', values.length > 0);
      valueInput.setCustomValidity(values.length ? '' : 'Please select at least one option.');
    }

    function setOpen(open) {
      panel.hidden = !open;
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      root.classList.toggle('is-open', open);
    }

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      setOpen(panel.hidden);
    });

    checkboxes.forEach(function (box) {
      box.addEventListener('change', sync);
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setOpen(false);
    });

    valueInput.addEventListener('invalid', function (event) {
      event.preventDefault();
      setOpen(true);
      trigger.focus();
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        sync();
        if (!valueInput.checkValidity()) {
          event.preventDefault();
          setOpen(true);
          trigger.focus();
        }
      });
    }

    sync();
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-mn-multiselect]')
      .forEach(initMultiselect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
